import { ChangeEvent, FocusEvent } from 'react';
import { FormikErrors } from 'formik';
import { AttributeFormState } from '@idw-types/state/attribute-form-state';
import { Logger } from '@utils/logger';
import { AXNUITextInputWithErrorMessage } from '@iddataweb/idw-common-ui/containers';

type AadharCardNumberInputProps = {
	title: string;
	attribute: AttributeFormState;
	fieldName: string;
	fieldTouched: boolean;
	fieldError: string;
	fieldIsInvalid: boolean;
	fieldShouldBeHighlighted: boolean;
	setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
	onBlur: (event: FocusEvent<HTMLInputElement>) => void;
	onSetSubmitValue: (data: any) => void;
	isSubmitting: boolean;
};

export const AadharCardNumberInput = (props: AadharCardNumberInputProps) => {
	const {
		title,
		attribute,
		fieldName,
		fieldTouched,
		fieldError,
		fieldIsInvalid,
		fieldShouldBeHighlighted,
		setFieldTouched,
		setFieldValue,
		onBlur,
		onSetSubmitValue,
		isSubmitting
	} = props;

	const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		Logger.info('[AadharCardNumberInput] submit value: ', value);
		const inputData = { aadharCardNumber: value };
		onSetSubmitValue({ inputData });
		await setFieldValue(fieldName, value);
		setFieldTouched(fieldName, true, true);
	};

	return (
		<AXNUITextInputWithErrorMessage
			autocomplete={"new-password"}
			controlId={`aadharCard${attribute.id}`}
			automationId={`aadharCard${attribute.id}`}
			onChange={handleChange}
			value={attribute.inputData.aadharCardNumber}
			fieldName={fieldName}
			fieldTouched={fieldTouched}
			fieldError={fieldError}
			fieldIsInvalid={fieldIsInvalid}
			fieldShouldBeHighlighted={fieldShouldBeHighlighted}
			onBlur={onBlur}
			setFieldTouched={setFieldTouched}
			isSubmitting={isSubmitting}
			isDisabled={attribute.isDisabled}
			isPlaceholder={attribute.isPlaceholder}
			isOptional={attribute.optional}
			title={title}
			placeholder={attribute.placeholder ? attribute.placeholder : undefined}
		/>
	);
};